module.exports = __webpack_public_path__ + "img/img-8.e0b880f5.png";